import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const testimonials = [
  {
    quote: "Before PixelCraft, we had nothing online. Now we rank on page 1 for our main keywords and get 3–5 new enquiries a week. Best investment we ever made.",
    name: "Sarah Mitchell",
    role: "Owner, Mitchell Plumbing & Heating",
    avatar: "https://public.readdy.ai/ai/img_res/2785c4fa3bddb59273d88c7bc9f185c8.jpg",
    results: "+312% website traffic",
    stars: 5,
  },
  {
    quote: "I was sceptical at first — I&apos;d been burned by another agency before. But the team at PixelCraft delivered exactly what they promised, on time and on budget.",
    name: "James Okonkwo",
    role: "Founder, Okonkwo Consulting",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20smiling%20black%20man%20in%20his%2030s%2C%20natural%20light%2C%20clean%20light%20background%2C%20warm%20tones%2C%20confident%20expression%2C%20professional%20attire&width=120&height=120&seq=avatar-002&orientation=squarish",
    results: "Doubled monthly leads",
    stars: 5,
  },
  {
    quote: "Our old site looked like it was built in 2010. The redesign completely transformed how customers see us. We look like a premium brand now — and our prices reflect that.",
    name: "Claire & David Webb",
    role: "Directors, Webb&apos;s Landscaping",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20smiling%20woman%20in%20her%2030s%2C%20outdoors%2C%20natural%20light%2C%20relaxed%20friendly%20expression%2C%20casual%20professional%20look&width=120&height=120&seq=avatar-003&orientation=squarish",
    results: "+180% increase in quotes",
    stars: 5,
  },
  {
    quote: "The local SEO work has been incredible. We went from not appearing at all for our town name to being the first result on Google Maps within 6 weeks.",
    name: "Mark Tanner",
    role: "Owner, Tanner&apos;s Auto Repair",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20smiling%20man%20in%20his%2050s%2C%20natural%20light%2C%20clean%20background%2C%20warm%20tones%2C%20honest%20friendly%20expression&width=120&height=120&seq=avatar-004&orientation=squarish",
    results: "First on Google Maps",
    stars: 5,
  },
];

export default function TestimonialsSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="section-pad bg-stone-50" ref={ref}>
      <div className="container-md">
        <div
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="text-accent text-xs font-semibold uppercase tracking-[0.2em] mb-4 block">
            Real results
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-zinc-900">
            Don&apos;t take our word for it
          </h2>
          <p className="text-zinc-500 mt-4 max-w-xl mx-auto text-base">
            Here&apos;s what real small business owners say after working with us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`bg-white rounded-2xl p-7 flex flex-col gap-5 transition-all duration-500 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: t.stars }).map((_, j) => (
                  <span key={j} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm" />
                  </span>
                ))}
              </div>

              {/* Quote */}
              <p
                className="text-zinc-700 text-[15px] leading-relaxed flex-1"
                dangerouslySetInnerHTML={{ __html: `"${t.quote}"` }}
              />

              {/* Person + result */}
              <div className="flex items-center gap-4 pt-4 border-t border-zinc-100">
                <div className="w-12 h-12 flex items-center justify-center shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-12 h-12 rounded-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p
                    className="font-semibold text-zinc-900 text-sm"
                    dangerouslySetInnerHTML={{ __html: t.name }}
                  />
                  <p
                    className="text-zinc-500 text-xs mt-0.5"
                    dangerouslySetInnerHTML={{ __html: t.role }}
                  />
                </div>
                <span className="shrink-0 text-xs font-semibold text-emerald-700 bg-emerald-50 px-3 py-1.5 rounded-full whitespace-nowrap">
                  {t.results}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Aggregate stats */}
        <div
          className={`mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 transition-all duration-700 delay-400 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          {[
            { val: "100+", label: "Websites Built" },
            { val: "94%", label: "Client Retention Rate" },
            { val: "247%", label: "Avg. Lead Increase" },
            { val: "5★", label: "Average Review Score" },
          ].map((s) => (
            <div key={s.label} className="text-center bg-white rounded-2xl p-5">
              <p className="font-heading text-3xl font-bold text-zinc-900">{s.val}</p>
              <p className="text-zinc-500 text-sm mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
